/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateCoconutByType = /* GraphQL */ `
  subscription OnCreateCoconutByType($type: String) {
    onCreateCoconutByType(type: $type) {
      firstField
      id
      type
      owner
      createdBy
      updatedBy
      middleName
      firstName
      lastName
      email
      phone
      authorityFirstName
      authorityMiddleName
      authorityLastName
      authorityEmail
      originalEmail
      authorityPhoneCountryCode
      authorityPhone
      phoneCountryCode
      profilePhoto
      phoneNumberVerified
      smsActivityNotificationsEnabled
      emailMarketingNotificationsEnabled
      emailTransferStatusNotificationsEnabled
      smsTransferStatusNotificationsEnabled
      opportunityLost
      mfaReminderEnabled
      affiliateName
      affiliateId
      affiliateEnabled
      affiliateEmployee
      affiliateEmployeeEmail
      affiliateEmployeeId
      affiliateBranch
      otherSource
      trackingId
      status
      expectedTradingDate
      confidence
      closedDate
      registrationDate
      autoBookedDate
      currencyTo
      currencyFrom
      countryTo
      countryFrom
      purpose
      otherPurpose
      estimatedValue
      unqualifiedReason
      countryOfBirth
      birthDate
      birthDateString
      cxManager
      accountManager
      kycRequest
      kycResponse
      frequency
      fundsGoingtoDiffPerson
      fundsFromCustomer
      kycScore
      kycProvider
      documentIssuedBy
      complianceScore
      documentId
      expiry
      issuer
      currencyCloudId
      currencyCloudContactId
      currencyCloudReference
      documentType
      streetAddress
      streetAddressUnitNumber
      streetAddressNumber
      streetAddressName
      streetAddressType
      city
      state
      postcode
      country
      countryCode
      mfaEnabled
      corporateStreetAddress
      corporateStreetUnitNumber
      corporateStreetNumber
      corporateStreetName
      corporateStreetType
      corporateCity
      corporateState
      corporatePostcode
      corporateCountry
      qualifiedDate
      createdAt
      updatedAt
      ipAddress
      notes
      documentExpiry
      dealing
      bene
      parentId
      parentType
      secondParentId
      secondParentType
      sendId
      counter
      assignee
      inHouseAccount
      manualConvertRegistration
      proposedTradingDate
      proposedMovingDate
      iftiType
      tradeId
      linkedPaymentId
      submitDate
      submissionDate
      overrideFieldsV2
      manualActionFieldsV2
      autoOverrideFields
      beneOverrideFields
      regOverrideFields
      austracErrors
      fileName
      austracReference
      leadId
      isAutoRegistered
      isAutoVerified
      title
      completed
      description
      complianceEvent
      isComplianceCheckList
      stepsTaken
      decisionMade
      decisionVerified
      furtherAction
      verifiedBy
      dueDate
      businessName
      registrationNumber
      businessType
      industry
      website
      businessRole
      beneficiaryBankAccountCountry
      beneficiaryType
      bicSwiftCode
      bsbCode
      bicSwiftAccountNumber
      ibanAccountNumber
      iban
      sortCodeNumber
      clabeNumber
      cnapsNumber
      abaCode
      abaAccountNumber
      ifscNumber
      bankName
      bankCode
      deactivateReason
      accountNumber
      inCurrencyCloud
      lastContact
      beneVerified
      businessRepConfirmed
      termsAccepted
      balances
      docShortId
      docType
      docSubType
      docInstructions
      docIssuingCountry
      docRequestedDate
      docRequestedBy
      docRequestType
      docLicenceVersion
      docExpiryDate
      docExpiryDateString
      docId
      docCardNumber
      docUploadedDate
      docUploadedBy
      docRegion
      docTag
      docStatus
      docAssessmentDate
      docAssessmentBy
      docKey
      docKeys
      showToClient
      docNotApprovedReason
      userId
      lookupType
      lookupValue
      rolename
      permissions
      allowedFields
      userGroups
      features
      affiliates
      unqualifiedReasons
      transferPurposes
      transferAmounts
      countries
      currencies
      blacklistedCurrencies
      newItem
      oldItem
      action
      unread
      customerName
      customerEmail
      customerDefaultPricingPlanId
      targetRate
      accountManagerPhoneNumber
      canSendAccountManagerRateAlert
      accountManagerRateAlertEmailSent
      estAudRevenue
      actualAudRevenue
      tradePenaltyIncome
      settlementDate
      conversionDate
      shortReference
      creatorContactId
      accountId
      currencyPair
      buyCurrency
      iftiWitheld
      iftiWitheldDescription
      sellCurrency
      clientBuyAmount
      clientSellAmount
      sellAmount
      bookedSellAmount
      bookedBuyAmount
      bookedClientRate
      bookedMargin
      fixedSide
      coreRate
      partnerRate
      partnerStatus
      partnerBuyAmount
      partnerSellAmount
      clientRate
      depositRequired
      depositAmount
      depositCurrency
      depositStatus
      depositRequiredAt
      paymentIds
      sendPaymentIds
      documentsRequired
      unallocatedFunds
      fundsReceived
      fullFundsReceived
      thirdPartyPayment
      addressNotValidated
      fullFundsReceivedDate
      uniqueRequestId
      midMarketRate
      amount
      audAmount
      beneficiaryId
      currencyCloudBeneId
      currency
      reference
      reason
      paymentType
      paymentDate
      transferredAt
      authorisationStepsRequired
      lastUpdaterContactId
      conversionId
      sendConversionId
      failureReason
      payerId
      payerDetailsSource
      paymentGroupId
      failureReturnedAmount
      ultimateBeneficiaryName
      purposeCode
      chargeType
      feeAmount
      feeCurrency
      onBehalfOf
      hideFromCustomerActivity
      isFirstTrade
      balanceId
      balanceAmount
      transactionType
      relatedEntityType
      relatedEntityId
      relatedEntityShortReference
      settlesAt
      completedAt
      recipientName
      legacyContractId
      contractSent
      receiptSent
      autoSendContractNote
      manualSendContractNote
      manualSendReceipt
      manualSendTempPassword
      manualSendFundsInEmail
      manualSendDocumentsNeededEmail
      manualSendRegistrationFailed
      sendLeadInvite
      sendNewLeadNotification
      leadSource
      autoPushedToCC
      isCreatedWithoutLead
      isCreatedFromReg
      markAsCompleted
      compliancePending
      beneStatus
      beneCurrencyCloudId
      lastNoteAddedTime
      poaDocInstructions
      poiPhotoDocInstructions
      poiDocInstructions
      invoiceDate
      invoiceNumber
      highRiskCountries
      extremeHighRiskCountries
      highRiskCurrencies
      extremeHighRiskCurrencies
      highRiskPurposes
      values
      groupCaps
      riskDetails
      complexBusinessStructure
      businessOperatingYear
      failedPepSanctionsCheck
      pricingPlanId
      pricingPlanName
      pricingPlanMargin
      pricingPlanOutOfHoursMargin
      pricingPlanDefault
      pricingPlanBankRateComparison
      pricingPlanBankSendingFee
      customerDailyTradeLimit
      highRiskCustomerDailyTradeLimit
      customerMinTradeValue
      customerNotificationCreated
      customerFirstName
      customerLastName
      customerBusinessName
      link
      header
      poliTransactionRef
      portalSource
      error
      field
      rank
      rotation
      current
      value
      utmSource
      mappedAffiliateId
      registrationSource
      expireTime
      margin
      createdSource
      adviserName
      adviserEmail
      adviserPhoneCountryCode
      adviserPhone
      commission
      payInBSB
      payInAccNo
      payInABAStatus
      payInAccountName
      payInPayIdAlias
      payInPayIdStatus
      payInPayIdName
      payInBPayCRN
      payInBPayBillerCode
      incomingFundType
      incomingFundProvider
      incomingFundDetails
      paymentReference
      loginSource
      notificationType
      pricingStructureType
      pricingStructureSettings
      beneficiariesOfTrust
      directors
      webhookSecret
      transactionalApiWebhookUrls
      transactionalAPIRegistration
      eburyRegistration
      eburyNumber
      tradeIds
      activeCurrencies
      sourceAccountId
      sourceAccountName
      sourceAccountSendID
      sourceAccountType
      destinationAccountId
      destinationAccountName
      destinationAccountSendID
      destinationAccountType
      storeAUDRevenueInCC
      syncedEvent
      syncedAt
      apiOrganisationType
      originalRegistrationId
      financeAccount
      metadata
      name
      code
      ledgerId
      ledgerAccountId
      normalBalance
      frankieUboRequestId
      frankieUboEntityId
      partyName
      partyAddress
      connectionId
      internalAccountId
      accountDetails
      routingDetails
      virtualAccountId
      routingAccountName
      creditLedgerAccountId
      debitLedgerAccountId
      vrnLegalAcknowledgement
      confirmedTradeAmount
      leadConfidence
      nextTaskDueDate
      registrationBoomerangReason
      corporatePurposes
      doesNotUseWebsite
      marketingDescription
      businessHasTrust
      otherBusinessRole
      expectedMargin
      immediateTransfer
      pexaOptInValidated
      pexaOptInAt
      lastField
    }
  }
`;
export const onUpdateCoconutByType = /* GraphQL */ `
  subscription OnUpdateCoconutByType($type: String) {
    onUpdateCoconutByType(type: $type) {
      firstField
      id
      type
      owner
      createdBy
      updatedBy
      middleName
      firstName
      lastName
      email
      phone
      authorityFirstName
      authorityMiddleName
      authorityLastName
      authorityEmail
      originalEmail
      authorityPhoneCountryCode
      authorityPhone
      phoneCountryCode
      profilePhoto
      phoneNumberVerified
      smsActivityNotificationsEnabled
      emailMarketingNotificationsEnabled
      emailTransferStatusNotificationsEnabled
      smsTransferStatusNotificationsEnabled
      opportunityLost
      mfaReminderEnabled
      affiliateName
      affiliateId
      affiliateEnabled
      affiliateEmployee
      affiliateEmployeeEmail
      affiliateEmployeeId
      affiliateBranch
      otherSource
      trackingId
      status
      expectedTradingDate
      confidence
      closedDate
      registrationDate
      autoBookedDate
      currencyTo
      currencyFrom
      countryTo
      countryFrom
      purpose
      otherPurpose
      estimatedValue
      unqualifiedReason
      countryOfBirth
      birthDate
      birthDateString
      cxManager
      accountManager
      kycRequest
      kycResponse
      frequency
      fundsGoingtoDiffPerson
      fundsFromCustomer
      kycScore
      kycProvider
      documentIssuedBy
      complianceScore
      documentId
      expiry
      issuer
      currencyCloudId
      currencyCloudContactId
      currencyCloudReference
      documentType
      streetAddress
      streetAddressUnitNumber
      streetAddressNumber
      streetAddressName
      streetAddressType
      city
      state
      postcode
      country
      countryCode
      mfaEnabled
      corporateStreetAddress
      corporateStreetUnitNumber
      corporateStreetNumber
      corporateStreetName
      corporateStreetType
      corporateCity
      corporateState
      corporatePostcode
      corporateCountry
      qualifiedDate
      createdAt
      updatedAt
      ipAddress
      notes
      documentExpiry
      dealing
      bene
      parentId
      parentType
      secondParentId
      secondParentType
      sendId
      counter
      assignee
      inHouseAccount
      manualConvertRegistration
      proposedTradingDate
      proposedMovingDate
      iftiType
      tradeId
      linkedPaymentId
      submitDate
      submissionDate
      overrideFieldsV2
      manualActionFieldsV2
      autoOverrideFields
      beneOverrideFields
      regOverrideFields
      austracErrors
      fileName
      austracReference
      leadId
      isAutoRegistered
      isAutoVerified
      title
      completed
      description
      complianceEvent
      isComplianceCheckList
      stepsTaken
      decisionMade
      decisionVerified
      furtherAction
      verifiedBy
      dueDate
      businessName
      registrationNumber
      businessType
      industry
      website
      businessRole
      beneficiaryBankAccountCountry
      beneficiaryType
      bicSwiftCode
      bsbCode
      bicSwiftAccountNumber
      ibanAccountNumber
      iban
      sortCodeNumber
      clabeNumber
      cnapsNumber
      abaCode
      abaAccountNumber
      ifscNumber
      bankName
      bankCode
      deactivateReason
      accountNumber
      inCurrencyCloud
      lastContact
      beneVerified
      businessRepConfirmed
      termsAccepted
      balances
      docShortId
      docType
      docSubType
      docInstructions
      docIssuingCountry
      docRequestedDate
      docRequestedBy
      docRequestType
      docLicenceVersion
      docExpiryDate
      docExpiryDateString
      docId
      docCardNumber
      docUploadedDate
      docUploadedBy
      docRegion
      docTag
      docStatus
      docAssessmentDate
      docAssessmentBy
      docKey
      docKeys
      showToClient
      docNotApprovedReason
      userId
      lookupType
      lookupValue
      rolename
      permissions
      allowedFields
      userGroups
      features
      affiliates
      unqualifiedReasons
      transferPurposes
      transferAmounts
      countries
      currencies
      blacklistedCurrencies
      newItem
      oldItem
      action
      unread
      customerName
      customerEmail
      customerDefaultPricingPlanId
      targetRate
      accountManagerPhoneNumber
      canSendAccountManagerRateAlert
      accountManagerRateAlertEmailSent
      estAudRevenue
      actualAudRevenue
      tradePenaltyIncome
      settlementDate
      conversionDate
      shortReference
      creatorContactId
      accountId
      currencyPair
      buyCurrency
      iftiWitheld
      iftiWitheldDescription
      sellCurrency
      clientBuyAmount
      clientSellAmount
      sellAmount
      bookedSellAmount
      bookedBuyAmount
      bookedClientRate
      bookedMargin
      fixedSide
      coreRate
      partnerRate
      partnerStatus
      partnerBuyAmount
      partnerSellAmount
      clientRate
      depositRequired
      depositAmount
      depositCurrency
      depositStatus
      depositRequiredAt
      paymentIds
      sendPaymentIds
      documentsRequired
      unallocatedFunds
      fundsReceived
      fullFundsReceived
      thirdPartyPayment
      addressNotValidated
      fullFundsReceivedDate
      uniqueRequestId
      midMarketRate
      amount
      audAmount
      beneficiaryId
      currencyCloudBeneId
      currency
      reference
      reason
      paymentType
      paymentDate
      transferredAt
      authorisationStepsRequired
      lastUpdaterContactId
      conversionId
      sendConversionId
      failureReason
      payerId
      payerDetailsSource
      paymentGroupId
      failureReturnedAmount
      ultimateBeneficiaryName
      purposeCode
      chargeType
      feeAmount
      feeCurrency
      onBehalfOf
      hideFromCustomerActivity
      isFirstTrade
      balanceId
      balanceAmount
      transactionType
      relatedEntityType
      relatedEntityId
      relatedEntityShortReference
      settlesAt
      completedAt
      recipientName
      legacyContractId
      contractSent
      receiptSent
      autoSendContractNote
      manualSendContractNote
      manualSendReceipt
      manualSendTempPassword
      manualSendFundsInEmail
      manualSendDocumentsNeededEmail
      manualSendRegistrationFailed
      sendLeadInvite
      sendNewLeadNotification
      leadSource
      autoPushedToCC
      isCreatedWithoutLead
      isCreatedFromReg
      markAsCompleted
      compliancePending
      beneStatus
      beneCurrencyCloudId
      lastNoteAddedTime
      poaDocInstructions
      poiPhotoDocInstructions
      poiDocInstructions
      invoiceDate
      invoiceNumber
      highRiskCountries
      extremeHighRiskCountries
      highRiskCurrencies
      extremeHighRiskCurrencies
      highRiskPurposes
      values
      groupCaps
      riskDetails
      complexBusinessStructure
      businessOperatingYear
      failedPepSanctionsCheck
      pricingPlanId
      pricingPlanName
      pricingPlanMargin
      pricingPlanOutOfHoursMargin
      pricingPlanDefault
      pricingPlanBankRateComparison
      pricingPlanBankSendingFee
      customerDailyTradeLimit
      highRiskCustomerDailyTradeLimit
      customerMinTradeValue
      customerNotificationCreated
      customerFirstName
      customerLastName
      customerBusinessName
      link
      header
      poliTransactionRef
      portalSource
      error
      field
      rank
      rotation
      current
      value
      utmSource
      mappedAffiliateId
      registrationSource
      expireTime
      margin
      createdSource
      adviserName
      adviserEmail
      adviserPhoneCountryCode
      adviserPhone
      commission
      payInBSB
      payInAccNo
      payInABAStatus
      payInAccountName
      payInPayIdAlias
      payInPayIdStatus
      payInPayIdName
      payInBPayCRN
      payInBPayBillerCode
      incomingFundType
      incomingFundProvider
      incomingFundDetails
      paymentReference
      loginSource
      notificationType
      pricingStructureType
      pricingStructureSettings
      beneficiariesOfTrust
      directors
      webhookSecret
      transactionalApiWebhookUrls
      transactionalAPIRegistration
      eburyRegistration
      eburyNumber
      tradeIds
      activeCurrencies
      sourceAccountId
      sourceAccountName
      sourceAccountSendID
      sourceAccountType
      destinationAccountId
      destinationAccountName
      destinationAccountSendID
      destinationAccountType
      storeAUDRevenueInCC
      syncedEvent
      syncedAt
      apiOrganisationType
      originalRegistrationId
      financeAccount
      metadata
      name
      code
      ledgerId
      ledgerAccountId
      normalBalance
      frankieUboRequestId
      frankieUboEntityId
      partyName
      partyAddress
      connectionId
      internalAccountId
      accountDetails
      routingDetails
      virtualAccountId
      routingAccountName
      creditLedgerAccountId
      debitLedgerAccountId
      vrnLegalAcknowledgement
      confirmedTradeAmount
      leadConfidence
      nextTaskDueDate
      registrationBoomerangReason
      corporatePurposes
      doesNotUseWebsite
      marketingDescription
      businessHasTrust
      otherBusinessRole
      expectedMargin
      immediateTransfer
      pexaOptInValidated
      pexaOptInAt
      lastField
    }
  }
`;
export const onCreateCoconutByOwnerType = /* GraphQL */ `
  subscription OnCreateCoconutByOwnerType($owner: String, $type: String) {
    onCreateCoconutByOwnerType(owner: $owner, type: $type) {
      firstField
      id
      type
      owner
      createdBy
      updatedBy
      middleName
      firstName
      lastName
      email
      phone
      authorityFirstName
      authorityMiddleName
      authorityLastName
      authorityEmail
      originalEmail
      authorityPhoneCountryCode
      authorityPhone
      phoneCountryCode
      profilePhoto
      phoneNumberVerified
      smsActivityNotificationsEnabled
      emailMarketingNotificationsEnabled
      emailTransferStatusNotificationsEnabled
      smsTransferStatusNotificationsEnabled
      opportunityLost
      mfaReminderEnabled
      affiliateName
      affiliateId
      affiliateEnabled
      affiliateEmployee
      affiliateEmployeeEmail
      affiliateEmployeeId
      affiliateBranch
      otherSource
      trackingId
      status
      expectedTradingDate
      confidence
      closedDate
      registrationDate
      autoBookedDate
      currencyTo
      currencyFrom
      countryTo
      countryFrom
      purpose
      otherPurpose
      estimatedValue
      unqualifiedReason
      countryOfBirth
      birthDate
      birthDateString
      cxManager
      accountManager
      kycRequest
      kycResponse
      frequency
      fundsGoingtoDiffPerson
      fundsFromCustomer
      kycScore
      kycProvider
      documentIssuedBy
      complianceScore
      documentId
      expiry
      issuer
      currencyCloudId
      currencyCloudContactId
      currencyCloudReference
      documentType
      streetAddress
      streetAddressUnitNumber
      streetAddressNumber
      streetAddressName
      streetAddressType
      city
      state
      postcode
      country
      countryCode
      mfaEnabled
      corporateStreetAddress
      corporateStreetUnitNumber
      corporateStreetNumber
      corporateStreetName
      corporateStreetType
      corporateCity
      corporateState
      corporatePostcode
      corporateCountry
      qualifiedDate
      createdAt
      updatedAt
      ipAddress
      notes
      documentExpiry
      dealing
      bene
      parentId
      parentType
      secondParentId
      secondParentType
      sendId
      counter
      assignee
      inHouseAccount
      manualConvertRegistration
      proposedTradingDate
      proposedMovingDate
      iftiType
      tradeId
      linkedPaymentId
      submitDate
      submissionDate
      overrideFieldsV2
      manualActionFieldsV2
      autoOverrideFields
      beneOverrideFields
      regOverrideFields
      austracErrors
      fileName
      austracReference
      leadId
      isAutoRegistered
      isAutoVerified
      title
      completed
      description
      complianceEvent
      isComplianceCheckList
      stepsTaken
      decisionMade
      decisionVerified
      furtherAction
      verifiedBy
      dueDate
      businessName
      registrationNumber
      businessType
      industry
      website
      businessRole
      beneficiaryBankAccountCountry
      beneficiaryType
      bicSwiftCode
      bsbCode
      bicSwiftAccountNumber
      ibanAccountNumber
      iban
      sortCodeNumber
      clabeNumber
      cnapsNumber
      abaCode
      abaAccountNumber
      ifscNumber
      bankName
      bankCode
      deactivateReason
      accountNumber
      inCurrencyCloud
      lastContact
      beneVerified
      businessRepConfirmed
      termsAccepted
      balances
      docShortId
      docType
      docSubType
      docInstructions
      docIssuingCountry
      docRequestedDate
      docRequestedBy
      docRequestType
      docLicenceVersion
      docExpiryDate
      docExpiryDateString
      docId
      docCardNumber
      docUploadedDate
      docUploadedBy
      docRegion
      docTag
      docStatus
      docAssessmentDate
      docAssessmentBy
      docKey
      docKeys
      showToClient
      docNotApprovedReason
      userId
      lookupType
      lookupValue
      rolename
      permissions
      allowedFields
      userGroups
      features
      affiliates
      unqualifiedReasons
      transferPurposes
      transferAmounts
      countries
      currencies
      blacklistedCurrencies
      newItem
      oldItem
      action
      unread
      customerName
      customerEmail
      customerDefaultPricingPlanId
      targetRate
      accountManagerPhoneNumber
      canSendAccountManagerRateAlert
      accountManagerRateAlertEmailSent
      estAudRevenue
      actualAudRevenue
      tradePenaltyIncome
      settlementDate
      conversionDate
      shortReference
      creatorContactId
      accountId
      currencyPair
      buyCurrency
      iftiWitheld
      iftiWitheldDescription
      sellCurrency
      clientBuyAmount
      clientSellAmount
      sellAmount
      bookedSellAmount
      bookedBuyAmount
      bookedClientRate
      bookedMargin
      fixedSide
      coreRate
      partnerRate
      partnerStatus
      partnerBuyAmount
      partnerSellAmount
      clientRate
      depositRequired
      depositAmount
      depositCurrency
      depositStatus
      depositRequiredAt
      paymentIds
      sendPaymentIds
      documentsRequired
      unallocatedFunds
      fundsReceived
      fullFundsReceived
      thirdPartyPayment
      addressNotValidated
      fullFundsReceivedDate
      uniqueRequestId
      midMarketRate
      amount
      audAmount
      beneficiaryId
      currencyCloudBeneId
      currency
      reference
      reason
      paymentType
      paymentDate
      transferredAt
      authorisationStepsRequired
      lastUpdaterContactId
      conversionId
      sendConversionId
      failureReason
      payerId
      payerDetailsSource
      paymentGroupId
      failureReturnedAmount
      ultimateBeneficiaryName
      purposeCode
      chargeType
      feeAmount
      feeCurrency
      onBehalfOf
      hideFromCustomerActivity
      isFirstTrade
      balanceId
      balanceAmount
      transactionType
      relatedEntityType
      relatedEntityId
      relatedEntityShortReference
      settlesAt
      completedAt
      recipientName
      legacyContractId
      contractSent
      receiptSent
      autoSendContractNote
      manualSendContractNote
      manualSendReceipt
      manualSendTempPassword
      manualSendFundsInEmail
      manualSendDocumentsNeededEmail
      manualSendRegistrationFailed
      sendLeadInvite
      sendNewLeadNotification
      leadSource
      autoPushedToCC
      isCreatedWithoutLead
      isCreatedFromReg
      markAsCompleted
      compliancePending
      beneStatus
      beneCurrencyCloudId
      lastNoteAddedTime
      poaDocInstructions
      poiPhotoDocInstructions
      poiDocInstructions
      invoiceDate
      invoiceNumber
      highRiskCountries
      extremeHighRiskCountries
      highRiskCurrencies
      extremeHighRiskCurrencies
      highRiskPurposes
      values
      groupCaps
      riskDetails
      complexBusinessStructure
      businessOperatingYear
      failedPepSanctionsCheck
      pricingPlanId
      pricingPlanName
      pricingPlanMargin
      pricingPlanOutOfHoursMargin
      pricingPlanDefault
      pricingPlanBankRateComparison
      pricingPlanBankSendingFee
      customerDailyTradeLimit
      highRiskCustomerDailyTradeLimit
      customerMinTradeValue
      customerNotificationCreated
      customerFirstName
      customerLastName
      customerBusinessName
      link
      header
      poliTransactionRef
      portalSource
      error
      field
      rank
      rotation
      current
      value
      utmSource
      mappedAffiliateId
      registrationSource
      expireTime
      margin
      createdSource
      adviserName
      adviserEmail
      adviserPhoneCountryCode
      adviserPhone
      commission
      payInBSB
      payInAccNo
      payInABAStatus
      payInAccountName
      payInPayIdAlias
      payInPayIdStatus
      payInPayIdName
      payInBPayCRN
      payInBPayBillerCode
      incomingFundType
      incomingFundProvider
      incomingFundDetails
      paymentReference
      loginSource
      notificationType
      pricingStructureType
      pricingStructureSettings
      beneficiariesOfTrust
      directors
      webhookSecret
      transactionalApiWebhookUrls
      transactionalAPIRegistration
      eburyRegistration
      eburyNumber
      tradeIds
      activeCurrencies
      sourceAccountId
      sourceAccountName
      sourceAccountSendID
      sourceAccountType
      destinationAccountId
      destinationAccountName
      destinationAccountSendID
      destinationAccountType
      storeAUDRevenueInCC
      syncedEvent
      syncedAt
      apiOrganisationType
      originalRegistrationId
      financeAccount
      metadata
      name
      code
      ledgerId
      ledgerAccountId
      normalBalance
      frankieUboRequestId
      frankieUboEntityId
      partyName
      partyAddress
      connectionId
      internalAccountId
      accountDetails
      routingDetails
      virtualAccountId
      routingAccountName
      creditLedgerAccountId
      debitLedgerAccountId
      vrnLegalAcknowledgement
      confirmedTradeAmount
      leadConfidence
      nextTaskDueDate
      registrationBoomerangReason
      corporatePurposes
      doesNotUseWebsite
      marketingDescription
      businessHasTrust
      otherBusinessRole
      expectedMargin
      immediateTransfer
      pexaOptInValidated
      pexaOptInAt
      lastField
    }
  }
`;
export const onUpdateCoconutByOwnerType = /* GraphQL */ `
  subscription OnUpdateCoconutByOwnerType($owner: String, $type: String) {
    onUpdateCoconutByOwnerType(owner: $owner, type: $type) {
      firstField
      id
      type
      owner
      createdBy
      updatedBy
      middleName
      firstName
      lastName
      email
      phone
      authorityFirstName
      authorityMiddleName
      authorityLastName
      authorityEmail
      originalEmail
      authorityPhoneCountryCode
      authorityPhone
      phoneCountryCode
      profilePhoto
      phoneNumberVerified
      smsActivityNotificationsEnabled
      emailMarketingNotificationsEnabled
      emailTransferStatusNotificationsEnabled
      smsTransferStatusNotificationsEnabled
      opportunityLost
      mfaReminderEnabled
      affiliateName
      affiliateId
      affiliateEnabled
      affiliateEmployee
      affiliateEmployeeEmail
      affiliateEmployeeId
      affiliateBranch
      otherSource
      trackingId
      status
      expectedTradingDate
      confidence
      closedDate
      registrationDate
      autoBookedDate
      currencyTo
      currencyFrom
      countryTo
      countryFrom
      purpose
      otherPurpose
      estimatedValue
      unqualifiedReason
      countryOfBirth
      birthDate
      birthDateString
      cxManager
      accountManager
      kycRequest
      kycResponse
      frequency
      fundsGoingtoDiffPerson
      fundsFromCustomer
      kycScore
      kycProvider
      documentIssuedBy
      complianceScore
      documentId
      expiry
      issuer
      currencyCloudId
      currencyCloudContactId
      currencyCloudReference
      documentType
      streetAddress
      streetAddressUnitNumber
      streetAddressNumber
      streetAddressName
      streetAddressType
      city
      state
      postcode
      country
      countryCode
      mfaEnabled
      corporateStreetAddress
      corporateStreetUnitNumber
      corporateStreetNumber
      corporateStreetName
      corporateStreetType
      corporateCity
      corporateState
      corporatePostcode
      corporateCountry
      qualifiedDate
      createdAt
      updatedAt
      ipAddress
      notes
      documentExpiry
      dealing
      bene
      parentId
      parentType
      secondParentId
      secondParentType
      sendId
      counter
      assignee
      inHouseAccount
      manualConvertRegistration
      proposedTradingDate
      proposedMovingDate
      iftiType
      tradeId
      linkedPaymentId
      submitDate
      submissionDate
      overrideFieldsV2
      manualActionFieldsV2
      autoOverrideFields
      beneOverrideFields
      regOverrideFields
      austracErrors
      fileName
      austracReference
      leadId
      isAutoRegistered
      isAutoVerified
      title
      completed
      description
      complianceEvent
      isComplianceCheckList
      stepsTaken
      decisionMade
      decisionVerified
      furtherAction
      verifiedBy
      dueDate
      businessName
      registrationNumber
      businessType
      industry
      website
      businessRole
      beneficiaryBankAccountCountry
      beneficiaryType
      bicSwiftCode
      bsbCode
      bicSwiftAccountNumber
      ibanAccountNumber
      iban
      sortCodeNumber
      clabeNumber
      cnapsNumber
      abaCode
      abaAccountNumber
      ifscNumber
      bankName
      bankCode
      deactivateReason
      accountNumber
      inCurrencyCloud
      lastContact
      beneVerified
      businessRepConfirmed
      termsAccepted
      balances
      docShortId
      docType
      docSubType
      docInstructions
      docIssuingCountry
      docRequestedDate
      docRequestedBy
      docRequestType
      docLicenceVersion
      docExpiryDate
      docExpiryDateString
      docId
      docCardNumber
      docUploadedDate
      docUploadedBy
      docRegion
      docTag
      docStatus
      docAssessmentDate
      docAssessmentBy
      docKey
      docKeys
      showToClient
      docNotApprovedReason
      userId
      lookupType
      lookupValue
      rolename
      permissions
      allowedFields
      userGroups
      features
      affiliates
      unqualifiedReasons
      transferPurposes
      transferAmounts
      countries
      currencies
      blacklistedCurrencies
      newItem
      oldItem
      action
      unread
      customerName
      customerEmail
      customerDefaultPricingPlanId
      targetRate
      accountManagerPhoneNumber
      canSendAccountManagerRateAlert
      accountManagerRateAlertEmailSent
      estAudRevenue
      actualAudRevenue
      tradePenaltyIncome
      settlementDate
      conversionDate
      shortReference
      creatorContactId
      accountId
      currencyPair
      buyCurrency
      iftiWitheld
      iftiWitheldDescription
      sellCurrency
      clientBuyAmount
      clientSellAmount
      sellAmount
      bookedSellAmount
      bookedBuyAmount
      bookedClientRate
      bookedMargin
      fixedSide
      coreRate
      partnerRate
      partnerStatus
      partnerBuyAmount
      partnerSellAmount
      clientRate
      depositRequired
      depositAmount
      depositCurrency
      depositStatus
      depositRequiredAt
      paymentIds
      sendPaymentIds
      documentsRequired
      unallocatedFunds
      fundsReceived
      fullFundsReceived
      thirdPartyPayment
      addressNotValidated
      fullFundsReceivedDate
      uniqueRequestId
      midMarketRate
      amount
      audAmount
      beneficiaryId
      currencyCloudBeneId
      currency
      reference
      reason
      paymentType
      paymentDate
      transferredAt
      authorisationStepsRequired
      lastUpdaterContactId
      conversionId
      sendConversionId
      failureReason
      payerId
      payerDetailsSource
      paymentGroupId
      failureReturnedAmount
      ultimateBeneficiaryName
      purposeCode
      chargeType
      feeAmount
      feeCurrency
      onBehalfOf
      hideFromCustomerActivity
      isFirstTrade
      balanceId
      balanceAmount
      transactionType
      relatedEntityType
      relatedEntityId
      relatedEntityShortReference
      settlesAt
      completedAt
      recipientName
      legacyContractId
      contractSent
      receiptSent
      autoSendContractNote
      manualSendContractNote
      manualSendReceipt
      manualSendTempPassword
      manualSendFundsInEmail
      manualSendDocumentsNeededEmail
      manualSendRegistrationFailed
      sendLeadInvite
      sendNewLeadNotification
      leadSource
      autoPushedToCC
      isCreatedWithoutLead
      isCreatedFromReg
      markAsCompleted
      compliancePending
      beneStatus
      beneCurrencyCloudId
      lastNoteAddedTime
      poaDocInstructions
      poiPhotoDocInstructions
      poiDocInstructions
      invoiceDate
      invoiceNumber
      highRiskCountries
      extremeHighRiskCountries
      highRiskCurrencies
      extremeHighRiskCurrencies
      highRiskPurposes
      values
      groupCaps
      riskDetails
      complexBusinessStructure
      businessOperatingYear
      failedPepSanctionsCheck
      pricingPlanId
      pricingPlanName
      pricingPlanMargin
      pricingPlanOutOfHoursMargin
      pricingPlanDefault
      pricingPlanBankRateComparison
      pricingPlanBankSendingFee
      customerDailyTradeLimit
      highRiskCustomerDailyTradeLimit
      customerMinTradeValue
      customerNotificationCreated
      customerFirstName
      customerLastName
      customerBusinessName
      link
      header
      poliTransactionRef
      portalSource
      error
      field
      rank
      rotation
      current
      value
      utmSource
      mappedAffiliateId
      registrationSource
      expireTime
      margin
      createdSource
      adviserName
      adviserEmail
      adviserPhoneCountryCode
      adviserPhone
      commission
      payInBSB
      payInAccNo
      payInABAStatus
      payInAccountName
      payInPayIdAlias
      payInPayIdStatus
      payInPayIdName
      payInBPayCRN
      payInBPayBillerCode
      incomingFundType
      incomingFundProvider
      incomingFundDetails
      paymentReference
      loginSource
      notificationType
      pricingStructureType
      pricingStructureSettings
      beneficiariesOfTrust
      directors
      webhookSecret
      transactionalApiWebhookUrls
      transactionalAPIRegistration
      eburyRegistration
      eburyNumber
      tradeIds
      activeCurrencies
      sourceAccountId
      sourceAccountName
      sourceAccountSendID
      sourceAccountType
      destinationAccountId
      destinationAccountName
      destinationAccountSendID
      destinationAccountType
      storeAUDRevenueInCC
      syncedEvent
      syncedAt
      apiOrganisationType
      originalRegistrationId
      financeAccount
      metadata
      name
      code
      ledgerId
      ledgerAccountId
      normalBalance
      frankieUboRequestId
      frankieUboEntityId
      partyName
      partyAddress
      connectionId
      internalAccountId
      accountDetails
      routingDetails
      virtualAccountId
      routingAccountName
      creditLedgerAccountId
      debitLedgerAccountId
      vrnLegalAcknowledgement
      confirmedTradeAmount
      leadConfidence
      nextTaskDueDate
      registrationBoomerangReason
      corporatePurposes
      doesNotUseWebsite
      marketingDescription
      businessHasTrust
      otherBusinessRole
      expectedMargin
      immediateTransfer
      pexaOptInValidated
      pexaOptInAt
      lastField
    }
  }
`;
export const onCreateCoconutByTypeV2 = /* GraphQL */ `
  subscription OnCreateCoconutByTypeV2($type: String) {
    onCreateCoconutByTypeV2(type: $type) {
      firstField
      id
      type
      owner
      createdBy
      updatedBy
      middleName
      firstName
      lastName
      email
      phone
      authorityFirstName
      authorityMiddleName
      authorityLastName
      authorityEmail
      originalEmail
      authorityPhoneCountryCode
      authorityPhone
      phoneCountryCode
      profilePhoto
      phoneNumberVerified
      smsActivityNotificationsEnabled
      emailMarketingNotificationsEnabled
      emailTransferStatusNotificationsEnabled
      smsTransferStatusNotificationsEnabled
      opportunityLost
      mfaReminderEnabled
      affiliateName
      affiliateId
      affiliateEnabled
      affiliateEmployee
      affiliateEmployeeId
      affiliateEmployeeEmail
      affiliateBranch
      otherSource
      trackingId
      status
      expectedTradingDate
      confidence
      closedDate
      registrationDate
      autoBookedDate
      currencyTo
      currencyFrom
      countryTo
      countryFrom
      purpose
      otherPurpose
      estimatedValue
      unqualifiedReason
      countryOfBirth
      birthDate
      birthDateString
      cxManager
      accountManager
      kycRequest
      kycResponse
      frequency
      fundsGoingtoDiffPerson
      fundsFromCustomer
      kycScore
      kycProvider
      documentIssuedBy
      complianceScore
      documentId
      expiry
      issuer
      currencyCloudId
      currencyCloudContactId
      currencyCloudReference
      documentType
      streetAddress
      streetAddressUnitNumber
      streetAddressNumber
      streetAddressName
      streetAddressType
      city
      state
      postcode
      country
      countryCode
      mfaEnabled
      corporateStreetAddress
      corporateStreetUnitNumber
      corporateStreetNumber
      corporateStreetName
      corporateStreetType
      corporateCity
      corporateState
      corporatePostcode
      corporateCountry
      createdAt
      updatedAt
      qualifiedDate
      ipAddress
      notes
      documentExpiry
      dealing
      bene
      parentId
      parentType
      secondParentId
      secondParentType
      sendId
      counter
      assignee
      inHouseAccount
      manualConvertRegistration
      proposedTradingDate
      proposedMovingDate
      iftiType
      tradeId
      submitDate
      submissionDate
      linkedPaymentId
      overrideFieldsV2
      manualActionFieldsV2
      autoOverrideFields
      beneOverrideFields
      regOverrideFields
      austracErrors
      fileName
      austracReference
      leadId
      isAutoRegistered
      isAutoVerified
      title
      completed
      description
      complianceEvent
      isComplianceCheckList
      stepsTaken
      decisionMade
      decisionVerified
      furtherAction
      verifiedBy
      dueDate
      businessName
      registrationNumber
      businessType
      industry
      website
      businessRole
      beneficiaryBankAccountCountry
      beneficiaryType
      bicSwiftCode
      bsbCode
      bicSwiftAccountNumber
      ibanAccountNumber
      iban
      sortCodeNumber
      clabeNumber
      cnapsNumber
      abaCode
      abaAccountNumber
      ifscNumber
      bankName
      bankCode
      deactivateReason
      accountNumber
      inCurrencyCloud
      lastContact
      beneVerified
      businessRepConfirmed
      termsAccepted
      balances
      docShortId
      docType
      docSubType
      docInstructions
      docIssuingCountry
      docRequestedDate
      docRequestedBy
      docRequestType
      docLicenceVersion
      docExpiryDate
      docExpiryDateString
      docId
      docCardNumber
      docUploadedDate
      docUploadedBy
      docRegion
      docTag
      docStatus
      docAssessmentDate
      docAssessmentBy
      docKey
      docKeys
      showToClient
      docNotApprovedReason
      userId
      lookupType
      lookupValue
      rolename
      permissions
      allowedFields
      userGroups
      features
      affiliates
      unqualifiedReasons
      transferPurposes
      transferAmounts
      countries
      currencies
      blacklistedCurrencies
      newItem
      oldItem
      action
      unread
      customerName
      customerEmail
      customerDefaultPricingPlanId
      targetRate
      accountManagerPhoneNumber
      canSendAccountManagerRateAlert
      accountManagerRateAlertEmailSent
      estAudRevenue
      actualAudRevenue
      tradePenaltyIncome
      settlementDate
      conversionDate
      shortReference
      creatorContactId
      accountId
      iftiWitheld
      iftiWitheldDescription
      currencyPair
      buyCurrency
      sellCurrency
      clientBuyAmount
      clientSellAmount
      sellAmount
      bookedSellAmount
      bookedBuyAmount
      bookedClientRate
      bookedMargin
      fixedSide
      coreRate
      partnerRate
      partnerStatus
      partnerBuyAmount
      partnerSellAmount
      clientRate
      depositRequired
      depositAmount
      depositCurrency
      depositStatus
      depositRequiredAt
      paymentIds
      sendPaymentIds
      documentsRequired
      unallocatedFunds
      fundsReceived
      fullFundsReceived
      thirdPartyPayment
      addressNotValidated
      fullFundsReceivedDate
      uniqueRequestId
      midMarketRate
      amount
      audAmount
      beneficiaryId
      currencyCloudBeneId
      currency
      reference
      reason
      paymentType
      paymentDate
      transferredAt
      authorisationStepsRequired
      lastUpdaterContactId
      conversionId
      sendConversionId
      failureReason
      payerId
      payerDetailsSource
      paymentGroupId
      failureReturnedAmount
      ultimateBeneficiaryName
      purposeCode
      chargeType
      feeAmount
      feeCurrency
      onBehalfOf
      hideFromCustomerActivity
      isFirstTrade
      balanceId
      balanceAmount
      transactionType
      relatedEntityType
      relatedEntityId
      relatedEntityShortReference
      settlesAt
      completedAt
      recipientName
      legacyContractId
      contractSent
      receiptSent
      autoSendContractNote
      manualSendContractNote
      manualSendReceipt
      manualSendTempPassword
      manualSendFundsInEmail
      manualSendDocumentsNeededEmail
      manualSendRegistrationFailed
      sendLeadInvite
      sendNewLeadNotification
      leadSource
      autoPushedToCC
      isCreatedWithoutLead
      isCreatedFromReg
      markAsCompleted
      compliancePending
      beneStatus
      beneCurrencyCloudId
      lastNoteAddedTime
      poaDocInstructions
      poiPhotoDocInstructions
      poiDocInstructions
      invoiceDate
      invoiceNumber
      highRiskCountries
      extremeHighRiskCountries
      highRiskCurrencies
      extremeHighRiskCurrencies
      highRiskPurposes
      values
      groupCaps
      riskDetails
      complexBusinessStructure
      businessOperatingYear
      failedPepSanctionsCheck
      pricingPlanId
      pricingPlanName
      pricingPlanMargin
      pricingPlanOutOfHoursMargin
      pricingPlanDefault
      pricingPlanBankRateComparison
      pricingPlanBankSendingFee
      customerDailyTradeLimit
      highRiskCustomerDailyTradeLimit
      customerMinTradeValue
      customerNotificationCreated
      customerFirstName
      customerLastName
      customerBusinessName
      link
      header
      poliTransactionRef
      portalSource
      error
      field
      rank
      rotation
      current
      value
      utmSource
      mappedAffiliateId
      registrationSource
      expireTime
      margin
      createdSource
      adviserName
      adviserEmail
      adviserPhoneCountryCode
      adviserPhone
      commission
      payInBSB
      payInAccNo
      payInABAStatus
      payInAccountName
      payInPayIdAlias
      payInPayIdStatus
      payInPayIdName
      payInBPayCRN
      payInBPayBillerCode
      incomingFundType
      incomingFundProvider
      incomingFundDetails
      paymentReference
      loginSource
      notificationType
      pricingStructureType
      pricingStructureSettings
      beneficiariesOfTrust
      directors
      webhookSecret
      transactionalApiWebhookUrls
      transactionalAPIRegistration
      eburyRegistration
      eburyNumber
      storeAUDRevenueInCC
      syncedEvent
      syncedAt
      tradeIds
      activeCurrencies
      sourceAccountId
      sourceAccountSendID
      sourceAccountName
      sourceAccountType
      destinationAccountId
      destinationAccountName
      destinationAccountSendID
      destinationAccountType
      apiOrganisationType
      originalRegistrationId
      financeAccount
      metadata
      name
      code
      ledgerId
      ledgerAccountId
      normalBalance
      vrnLegalAcknowledgement
      frankieUboRequestId
      frankieUboEntityId
      partyName
      partyAddress
      connectionId
      internalAccountId
      accountDetails
      routingDetails
      virtualAccountId
      routingAccountName
      creditLedgerAccountId
      debitLedgerAccountId
      confirmedTradeAmount
      leadConfidence
      nextTaskDueDate
      registrationBoomerangReason
      corporatePurposes
      doesNotUseWebsite
      marketingDescription
      businessHasTrust
      otherBusinessRole
      expectedMargin
      immediateTransfer
      pexaOptInValidated
      pexaOptInAt
      lastField
    }
  }
`;
export const onUpdateCoconutByTypeV2 = /* GraphQL */ `
  subscription OnUpdateCoconutByTypeV2($type: String) {
    onUpdateCoconutByTypeV2(type: $type) {
      firstField
      id
      type
      owner
      createdBy
      updatedBy
      middleName
      firstName
      lastName
      email
      phone
      authorityFirstName
      authorityMiddleName
      authorityLastName
      authorityEmail
      originalEmail
      authorityPhoneCountryCode
      authorityPhone
      phoneCountryCode
      profilePhoto
      phoneNumberVerified
      smsActivityNotificationsEnabled
      emailMarketingNotificationsEnabled
      emailTransferStatusNotificationsEnabled
      smsTransferStatusNotificationsEnabled
      opportunityLost
      mfaReminderEnabled
      affiliateName
      affiliateId
      affiliateEnabled
      affiliateEmployee
      affiliateEmployeeId
      affiliateEmployeeEmail
      affiliateBranch
      otherSource
      trackingId
      status
      expectedTradingDate
      confidence
      closedDate
      registrationDate
      autoBookedDate
      currencyTo
      currencyFrom
      countryTo
      countryFrom
      purpose
      otherPurpose
      estimatedValue
      unqualifiedReason
      countryOfBirth
      birthDate
      birthDateString
      cxManager
      accountManager
      kycRequest
      kycResponse
      frequency
      fundsGoingtoDiffPerson
      fundsFromCustomer
      kycScore
      kycProvider
      documentIssuedBy
      complianceScore
      documentId
      expiry
      issuer
      currencyCloudId
      currencyCloudContactId
      currencyCloudReference
      documentType
      streetAddress
      streetAddressUnitNumber
      streetAddressNumber
      streetAddressName
      streetAddressType
      city
      state
      postcode
      country
      countryCode
      mfaEnabled
      corporateStreetAddress
      corporateStreetUnitNumber
      corporateStreetNumber
      corporateStreetName
      corporateStreetType
      corporateCity
      corporateState
      corporatePostcode
      corporateCountry
      createdAt
      updatedAt
      qualifiedDate
      ipAddress
      notes
      documentExpiry
      dealing
      bene
      parentId
      parentType
      secondParentId
      secondParentType
      sendId
      counter
      assignee
      inHouseAccount
      manualConvertRegistration
      proposedTradingDate
      proposedMovingDate
      iftiType
      tradeId
      submitDate
      submissionDate
      linkedPaymentId
      overrideFieldsV2
      manualActionFieldsV2
      autoOverrideFields
      beneOverrideFields
      regOverrideFields
      austracErrors
      fileName
      austracReference
      leadId
      isAutoRegistered
      isAutoVerified
      title
      completed
      description
      complianceEvent
      isComplianceCheckList
      stepsTaken
      decisionMade
      decisionVerified
      furtherAction
      verifiedBy
      dueDate
      businessName
      registrationNumber
      businessType
      industry
      website
      businessRole
      beneficiaryBankAccountCountry
      beneficiaryType
      bicSwiftCode
      bsbCode
      bicSwiftAccountNumber
      ibanAccountNumber
      iban
      sortCodeNumber
      clabeNumber
      cnapsNumber
      abaCode
      abaAccountNumber
      ifscNumber
      bankName
      bankCode
      deactivateReason
      accountNumber
      inCurrencyCloud
      lastContact
      beneVerified
      businessRepConfirmed
      termsAccepted
      balances
      docShortId
      docType
      docSubType
      docInstructions
      docIssuingCountry
      docRequestedDate
      docRequestedBy
      docRequestType
      docLicenceVersion
      docExpiryDate
      docExpiryDateString
      docId
      docCardNumber
      docUploadedDate
      docUploadedBy
      docRegion
      docTag
      docStatus
      docAssessmentDate
      docAssessmentBy
      docKey
      docKeys
      showToClient
      docNotApprovedReason
      userId
      lookupType
      lookupValue
      rolename
      permissions
      allowedFields
      userGroups
      features
      affiliates
      unqualifiedReasons
      transferPurposes
      transferAmounts
      countries
      currencies
      blacklistedCurrencies
      newItem
      oldItem
      action
      unread
      customerName
      customerEmail
      customerDefaultPricingPlanId
      targetRate
      accountManagerPhoneNumber
      canSendAccountManagerRateAlert
      accountManagerRateAlertEmailSent
      estAudRevenue
      actualAudRevenue
      tradePenaltyIncome
      settlementDate
      conversionDate
      shortReference
      creatorContactId
      accountId
      iftiWitheld
      iftiWitheldDescription
      currencyPair
      buyCurrency
      sellCurrency
      clientBuyAmount
      clientSellAmount
      sellAmount
      bookedSellAmount
      bookedBuyAmount
      bookedClientRate
      bookedMargin
      fixedSide
      coreRate
      partnerRate
      partnerStatus
      partnerBuyAmount
      partnerSellAmount
      clientRate
      depositRequired
      depositAmount
      depositCurrency
      depositStatus
      depositRequiredAt
      paymentIds
      sendPaymentIds
      documentsRequired
      unallocatedFunds
      fundsReceived
      fullFundsReceived
      thirdPartyPayment
      addressNotValidated
      fullFundsReceivedDate
      uniqueRequestId
      midMarketRate
      amount
      audAmount
      beneficiaryId
      currencyCloudBeneId
      currency
      reference
      reason
      paymentType
      paymentDate
      transferredAt
      authorisationStepsRequired
      lastUpdaterContactId
      conversionId
      sendConversionId
      failureReason
      payerId
      payerDetailsSource
      paymentGroupId
      failureReturnedAmount
      ultimateBeneficiaryName
      purposeCode
      chargeType
      feeAmount
      feeCurrency
      onBehalfOf
      hideFromCustomerActivity
      isFirstTrade
      balanceId
      balanceAmount
      transactionType
      relatedEntityType
      relatedEntityId
      relatedEntityShortReference
      settlesAt
      completedAt
      recipientName
      legacyContractId
      contractSent
      receiptSent
      autoSendContractNote
      manualSendContractNote
      manualSendReceipt
      manualSendTempPassword
      manualSendFundsInEmail
      manualSendDocumentsNeededEmail
      manualSendRegistrationFailed
      sendLeadInvite
      sendNewLeadNotification
      leadSource
      autoPushedToCC
      isCreatedWithoutLead
      isCreatedFromReg
      markAsCompleted
      compliancePending
      beneStatus
      beneCurrencyCloudId
      lastNoteAddedTime
      poaDocInstructions
      poiPhotoDocInstructions
      poiDocInstructions
      invoiceDate
      invoiceNumber
      highRiskCountries
      extremeHighRiskCountries
      highRiskCurrencies
      extremeHighRiskCurrencies
      highRiskPurposes
      values
      groupCaps
      riskDetails
      complexBusinessStructure
      businessOperatingYear
      failedPepSanctionsCheck
      pricingPlanId
      pricingPlanName
      pricingPlanMargin
      pricingPlanOutOfHoursMargin
      pricingPlanDefault
      pricingPlanBankRateComparison
      pricingPlanBankSendingFee
      customerDailyTradeLimit
      highRiskCustomerDailyTradeLimit
      customerMinTradeValue
      customerNotificationCreated
      customerFirstName
      customerLastName
      customerBusinessName
      link
      header
      poliTransactionRef
      portalSource
      error
      field
      rank
      rotation
      current
      value
      utmSource
      mappedAffiliateId
      registrationSource
      expireTime
      margin
      createdSource
      adviserName
      adviserEmail
      adviserPhoneCountryCode
      adviserPhone
      commission
      payInBSB
      payInAccNo
      payInABAStatus
      payInAccountName
      payInPayIdAlias
      payInPayIdStatus
      payInPayIdName
      payInBPayCRN
      payInBPayBillerCode
      incomingFundType
      incomingFundProvider
      incomingFundDetails
      paymentReference
      loginSource
      notificationType
      pricingStructureType
      pricingStructureSettings
      beneficiariesOfTrust
      directors
      webhookSecret
      transactionalApiWebhookUrls
      transactionalAPIRegistration
      eburyRegistration
      eburyNumber
      storeAUDRevenueInCC
      syncedEvent
      syncedAt
      tradeIds
      activeCurrencies
      sourceAccountId
      sourceAccountSendID
      sourceAccountName
      sourceAccountType
      destinationAccountId
      destinationAccountName
      destinationAccountSendID
      destinationAccountType
      apiOrganisationType
      originalRegistrationId
      financeAccount
      metadata
      name
      code
      ledgerId
      ledgerAccountId
      normalBalance
      vrnLegalAcknowledgement
      frankieUboRequestId
      frankieUboEntityId
      partyName
      partyAddress
      connectionId
      internalAccountId
      accountDetails
      routingDetails
      virtualAccountId
      routingAccountName
      creditLedgerAccountId
      debitLedgerAccountId
      confirmedTradeAmount
      leadConfidence
      nextTaskDueDate
      registrationBoomerangReason
      corporatePurposes
      doesNotUseWebsite
      marketingDescription
      businessHasTrust
      otherBusinessRole
      expectedMargin
      immediateTransfer
      pexaOptInValidated
      pexaOptInAt
      lastField
    }
  }
`;
export const onDeleteCoconutByTypeV2 = /* GraphQL */ `
  subscription OnDeleteCoconutByTypeV2($type: String) {
    onDeleteCoconutByTypeV2(type: $type) {
      firstField
      id
      type
      owner
      createdBy
      updatedBy
      middleName
      firstName
      lastName
      email
      phone
      authorityFirstName
      authorityMiddleName
      authorityLastName
      authorityEmail
      originalEmail
      authorityPhoneCountryCode
      authorityPhone
      phoneCountryCode
      profilePhoto
      phoneNumberVerified
      smsActivityNotificationsEnabled
      emailMarketingNotificationsEnabled
      emailTransferStatusNotificationsEnabled
      smsTransferStatusNotificationsEnabled
      opportunityLost
      mfaReminderEnabled
      affiliateName
      affiliateId
      affiliateEnabled
      affiliateEmployee
      affiliateEmployeeId
      affiliateEmployeeEmail
      affiliateBranch
      otherSource
      trackingId
      status
      expectedTradingDate
      confidence
      closedDate
      registrationDate
      autoBookedDate
      currencyTo
      currencyFrom
      countryTo
      countryFrom
      purpose
      otherPurpose
      estimatedValue
      unqualifiedReason
      countryOfBirth
      birthDate
      birthDateString
      cxManager
      accountManager
      kycRequest
      kycResponse
      frequency
      fundsGoingtoDiffPerson
      fundsFromCustomer
      kycScore
      kycProvider
      documentIssuedBy
      complianceScore
      documentId
      expiry
      issuer
      currencyCloudId
      currencyCloudContactId
      currencyCloudReference
      documentType
      streetAddress
      streetAddressUnitNumber
      streetAddressNumber
      streetAddressName
      streetAddressType
      city
      state
      postcode
      country
      countryCode
      mfaEnabled
      corporateStreetAddress
      corporateStreetUnitNumber
      corporateStreetNumber
      corporateStreetName
      corporateStreetType
      corporateCity
      corporateState
      corporatePostcode
      corporateCountry
      createdAt
      updatedAt
      qualifiedDate
      ipAddress
      notes
      documentExpiry
      dealing
      bene
      parentId
      parentType
      secondParentId
      secondParentType
      sendId
      counter
      assignee
      inHouseAccount
      manualConvertRegistration
      proposedTradingDate
      proposedMovingDate
      iftiType
      tradeId
      submitDate
      submissionDate
      linkedPaymentId
      overrideFieldsV2
      manualActionFieldsV2
      autoOverrideFields
      beneOverrideFields
      regOverrideFields
      austracErrors
      fileName
      austracReference
      leadId
      isAutoRegistered
      isAutoVerified
      title
      completed
      description
      complianceEvent
      isComplianceCheckList
      stepsTaken
      decisionMade
      decisionVerified
      furtherAction
      verifiedBy
      dueDate
      businessName
      registrationNumber
      businessType
      industry
      website
      businessRole
      beneficiaryBankAccountCountry
      beneficiaryType
      bicSwiftCode
      bsbCode
      bicSwiftAccountNumber
      ibanAccountNumber
      iban
      sortCodeNumber
      clabeNumber
      cnapsNumber
      abaCode
      abaAccountNumber
      ifscNumber
      bankName
      bankCode
      deactivateReason
      accountNumber
      inCurrencyCloud
      lastContact
      beneVerified
      businessRepConfirmed
      termsAccepted
      balances
      docShortId
      docType
      docSubType
      docInstructions
      docIssuingCountry
      docRequestedDate
      docRequestedBy
      docRequestType
      docLicenceVersion
      docExpiryDate
      docExpiryDateString
      docId
      docCardNumber
      docUploadedDate
      docUploadedBy
      docRegion
      docTag
      docStatus
      docAssessmentDate
      docAssessmentBy
      docKey
      docKeys
      showToClient
      docNotApprovedReason
      userId
      lookupType
      lookupValue
      rolename
      permissions
      allowedFields
      userGroups
      features
      affiliates
      unqualifiedReasons
      transferPurposes
      transferAmounts
      countries
      currencies
      blacklistedCurrencies
      newItem
      oldItem
      action
      unread
      customerName
      customerEmail
      customerDefaultPricingPlanId
      targetRate
      accountManagerPhoneNumber
      canSendAccountManagerRateAlert
      accountManagerRateAlertEmailSent
      estAudRevenue
      actualAudRevenue
      tradePenaltyIncome
      settlementDate
      conversionDate
      shortReference
      creatorContactId
      accountId
      iftiWitheld
      iftiWitheldDescription
      currencyPair
      buyCurrency
      sellCurrency
      clientBuyAmount
      clientSellAmount
      sellAmount
      bookedSellAmount
      bookedBuyAmount
      bookedClientRate
      bookedMargin
      fixedSide
      coreRate
      partnerRate
      partnerStatus
      partnerBuyAmount
      partnerSellAmount
      clientRate
      depositRequired
      depositAmount
      depositCurrency
      depositStatus
      depositRequiredAt
      paymentIds
      sendPaymentIds
      documentsRequired
      unallocatedFunds
      fundsReceived
      fullFundsReceived
      thirdPartyPayment
      addressNotValidated
      fullFundsReceivedDate
      uniqueRequestId
      midMarketRate
      amount
      audAmount
      beneficiaryId
      currencyCloudBeneId
      currency
      reference
      reason
      paymentType
      paymentDate
      transferredAt
      authorisationStepsRequired
      lastUpdaterContactId
      conversionId
      sendConversionId
      failureReason
      payerId
      payerDetailsSource
      paymentGroupId
      failureReturnedAmount
      ultimateBeneficiaryName
      purposeCode
      chargeType
      feeAmount
      feeCurrency
      onBehalfOf
      hideFromCustomerActivity
      isFirstTrade
      balanceId
      balanceAmount
      transactionType
      relatedEntityType
      relatedEntityId
      relatedEntityShortReference
      settlesAt
      completedAt
      recipientName
      legacyContractId
      contractSent
      receiptSent
      autoSendContractNote
      manualSendContractNote
      manualSendReceipt
      manualSendTempPassword
      manualSendFundsInEmail
      manualSendDocumentsNeededEmail
      manualSendRegistrationFailed
      sendLeadInvite
      sendNewLeadNotification
      leadSource
      autoPushedToCC
      isCreatedWithoutLead
      isCreatedFromReg
      markAsCompleted
      compliancePending
      beneStatus
      beneCurrencyCloudId
      lastNoteAddedTime
      poaDocInstructions
      poiPhotoDocInstructions
      poiDocInstructions
      invoiceDate
      invoiceNumber
      highRiskCountries
      extremeHighRiskCountries
      highRiskCurrencies
      extremeHighRiskCurrencies
      highRiskPurposes
      values
      groupCaps
      riskDetails
      complexBusinessStructure
      businessOperatingYear
      failedPepSanctionsCheck
      pricingPlanId
      pricingPlanName
      pricingPlanMargin
      pricingPlanOutOfHoursMargin
      pricingPlanDefault
      pricingPlanBankRateComparison
      pricingPlanBankSendingFee
      customerDailyTradeLimit
      highRiskCustomerDailyTradeLimit
      customerMinTradeValue
      customerNotificationCreated
      customerFirstName
      customerLastName
      customerBusinessName
      link
      header
      poliTransactionRef
      portalSource
      error
      field
      rank
      rotation
      current
      value
      utmSource
      mappedAffiliateId
      registrationSource
      expireTime
      margin
      createdSource
      adviserName
      adviserEmail
      adviserPhoneCountryCode
      adviserPhone
      commission
      payInBSB
      payInAccNo
      payInABAStatus
      payInAccountName
      payInPayIdAlias
      payInPayIdStatus
      payInPayIdName
      payInBPayCRN
      payInBPayBillerCode
      incomingFundType
      incomingFundProvider
      incomingFundDetails
      paymentReference
      loginSource
      notificationType
      pricingStructureType
      pricingStructureSettings
      beneficiariesOfTrust
      directors
      webhookSecret
      transactionalApiWebhookUrls
      transactionalAPIRegistration
      eburyRegistration
      eburyNumber
      storeAUDRevenueInCC
      syncedEvent
      syncedAt
      tradeIds
      activeCurrencies
      sourceAccountId
      sourceAccountSendID
      sourceAccountName
      sourceAccountType
      destinationAccountId
      destinationAccountName
      destinationAccountSendID
      destinationAccountType
      apiOrganisationType
      originalRegistrationId
      financeAccount
      metadata
      name
      code
      ledgerId
      ledgerAccountId
      normalBalance
      vrnLegalAcknowledgement
      frankieUboRequestId
      frankieUboEntityId
      partyName
      partyAddress
      connectionId
      internalAccountId
      accountDetails
      routingDetails
      virtualAccountId
      routingAccountName
      creditLedgerAccountId
      debitLedgerAccountId
      confirmedTradeAmount
      leadConfidence
      nextTaskDueDate
      registrationBoomerangReason
      corporatePurposes
      doesNotUseWebsite
      marketingDescription
      businessHasTrust
      otherBusinessRole
      expectedMargin
      immediateTransfer
      pexaOptInValidated
      pexaOptInAt
      lastField
    }
  }
`;
export const onCreateCoconutByOwnerTypeV2 = /* GraphQL */ `
  subscription OnCreateCoconutByOwnerTypeV2($owner: String, $type: String) {
    onCreateCoconutByOwnerTypeV2(owner: $owner, type: $type) {
      firstField
      id
      type
      owner
      createdBy
      updatedBy
      middleName
      firstName
      lastName
      email
      phone
      authorityFirstName
      authorityMiddleName
      authorityLastName
      authorityEmail
      originalEmail
      authorityPhoneCountryCode
      authorityPhone
      phoneCountryCode
      profilePhoto
      phoneNumberVerified
      smsActivityNotificationsEnabled
      emailMarketingNotificationsEnabled
      emailTransferStatusNotificationsEnabled
      smsTransferStatusNotificationsEnabled
      opportunityLost
      mfaReminderEnabled
      affiliateName
      affiliateId
      affiliateEnabled
      affiliateEmployee
      affiliateEmployeeId
      affiliateEmployeeEmail
      affiliateBranch
      otherSource
      trackingId
      status
      expectedTradingDate
      confidence
      closedDate
      registrationDate
      autoBookedDate
      currencyTo
      currencyFrom
      countryTo
      countryFrom
      purpose
      otherPurpose
      estimatedValue
      unqualifiedReason
      countryOfBirth
      birthDate
      birthDateString
      cxManager
      accountManager
      kycRequest
      kycResponse
      frequency
      fundsGoingtoDiffPerson
      fundsFromCustomer
      kycScore
      kycProvider
      documentIssuedBy
      complianceScore
      documentId
      expiry
      issuer
      currencyCloudId
      currencyCloudContactId
      currencyCloudReference
      documentType
      streetAddress
      streetAddressUnitNumber
      streetAddressNumber
      streetAddressName
      streetAddressType
      city
      state
      postcode
      country
      countryCode
      mfaEnabled
      corporateStreetAddress
      corporateStreetUnitNumber
      corporateStreetNumber
      corporateStreetName
      corporateStreetType
      corporateCity
      corporateState
      corporatePostcode
      corporateCountry
      createdAt
      updatedAt
      qualifiedDate
      ipAddress
      notes
      documentExpiry
      dealing
      bene
      parentId
      parentType
      secondParentId
      secondParentType
      sendId
      counter
      assignee
      inHouseAccount
      manualConvertRegistration
      proposedTradingDate
      proposedMovingDate
      iftiType
      tradeId
      submitDate
      submissionDate
      linkedPaymentId
      overrideFieldsV2
      manualActionFieldsV2
      autoOverrideFields
      beneOverrideFields
      regOverrideFields
      austracErrors
      fileName
      austracReference
      leadId
      isAutoRegistered
      isAutoVerified
      title
      completed
      description
      complianceEvent
      isComplianceCheckList
      stepsTaken
      decisionMade
      decisionVerified
      furtherAction
      verifiedBy
      dueDate
      businessName
      registrationNumber
      businessType
      industry
      website
      businessRole
      beneficiaryBankAccountCountry
      beneficiaryType
      bicSwiftCode
      bsbCode
      bicSwiftAccountNumber
      ibanAccountNumber
      iban
      sortCodeNumber
      clabeNumber
      cnapsNumber
      abaCode
      abaAccountNumber
      ifscNumber
      bankName
      bankCode
      deactivateReason
      accountNumber
      inCurrencyCloud
      lastContact
      beneVerified
      businessRepConfirmed
      termsAccepted
      balances
      docShortId
      docType
      docSubType
      docInstructions
      docIssuingCountry
      docRequestedDate
      docRequestedBy
      docRequestType
      docLicenceVersion
      docExpiryDate
      docExpiryDateString
      docId
      docCardNumber
      docUploadedDate
      docUploadedBy
      docRegion
      docTag
      docStatus
      docAssessmentDate
      docAssessmentBy
      docKey
      docKeys
      showToClient
      docNotApprovedReason
      userId
      lookupType
      lookupValue
      rolename
      permissions
      allowedFields
      userGroups
      features
      affiliates
      unqualifiedReasons
      transferPurposes
      transferAmounts
      countries
      currencies
      blacklistedCurrencies
      newItem
      oldItem
      action
      unread
      customerName
      customerEmail
      customerDefaultPricingPlanId
      targetRate
      accountManagerPhoneNumber
      canSendAccountManagerRateAlert
      accountManagerRateAlertEmailSent
      estAudRevenue
      actualAudRevenue
      tradePenaltyIncome
      settlementDate
      conversionDate
      shortReference
      creatorContactId
      accountId
      iftiWitheld
      iftiWitheldDescription
      currencyPair
      buyCurrency
      sellCurrency
      clientBuyAmount
      clientSellAmount
      sellAmount
      bookedSellAmount
      bookedBuyAmount
      bookedClientRate
      bookedMargin
      fixedSide
      coreRate
      partnerRate
      partnerStatus
      partnerBuyAmount
      partnerSellAmount
      clientRate
      depositRequired
      depositAmount
      depositCurrency
      depositStatus
      depositRequiredAt
      paymentIds
      sendPaymentIds
      documentsRequired
      unallocatedFunds
      fundsReceived
      fullFundsReceived
      thirdPartyPayment
      addressNotValidated
      fullFundsReceivedDate
      uniqueRequestId
      midMarketRate
      amount
      audAmount
      beneficiaryId
      currencyCloudBeneId
      currency
      reference
      reason
      paymentType
      paymentDate
      transferredAt
      authorisationStepsRequired
      lastUpdaterContactId
      conversionId
      sendConversionId
      failureReason
      payerId
      payerDetailsSource
      paymentGroupId
      failureReturnedAmount
      ultimateBeneficiaryName
      purposeCode
      chargeType
      feeAmount
      feeCurrency
      onBehalfOf
      hideFromCustomerActivity
      isFirstTrade
      balanceId
      balanceAmount
      transactionType
      relatedEntityType
      relatedEntityId
      relatedEntityShortReference
      settlesAt
      completedAt
      recipientName
      legacyContractId
      contractSent
      receiptSent
      autoSendContractNote
      manualSendContractNote
      manualSendReceipt
      manualSendTempPassword
      manualSendFundsInEmail
      manualSendDocumentsNeededEmail
      manualSendRegistrationFailed
      sendLeadInvite
      sendNewLeadNotification
      leadSource
      autoPushedToCC
      isCreatedWithoutLead
      isCreatedFromReg
      markAsCompleted
      compliancePending
      beneStatus
      beneCurrencyCloudId
      lastNoteAddedTime
      poaDocInstructions
      poiPhotoDocInstructions
      poiDocInstructions
      invoiceDate
      invoiceNumber
      highRiskCountries
      extremeHighRiskCountries
      highRiskCurrencies
      extremeHighRiskCurrencies
      highRiskPurposes
      values
      groupCaps
      riskDetails
      complexBusinessStructure
      businessOperatingYear
      failedPepSanctionsCheck
      pricingPlanId
      pricingPlanName
      pricingPlanMargin
      pricingPlanOutOfHoursMargin
      pricingPlanDefault
      pricingPlanBankRateComparison
      pricingPlanBankSendingFee
      customerDailyTradeLimit
      highRiskCustomerDailyTradeLimit
      customerMinTradeValue
      customerNotificationCreated
      customerFirstName
      customerLastName
      customerBusinessName
      link
      header
      poliTransactionRef
      portalSource
      error
      field
      rank
      rotation
      current
      value
      utmSource
      mappedAffiliateId
      registrationSource
      expireTime
      margin
      createdSource
      adviserName
      adviserEmail
      adviserPhoneCountryCode
      adviserPhone
      commission
      payInBSB
      payInAccNo
      payInABAStatus
      payInAccountName
      payInPayIdAlias
      payInPayIdStatus
      payInPayIdName
      payInBPayCRN
      payInBPayBillerCode
      incomingFundType
      incomingFundProvider
      incomingFundDetails
      paymentReference
      loginSource
      notificationType
      pricingStructureType
      pricingStructureSettings
      beneficiariesOfTrust
      directors
      webhookSecret
      transactionalApiWebhookUrls
      transactionalAPIRegistration
      eburyRegistration
      eburyNumber
      storeAUDRevenueInCC
      syncedEvent
      syncedAt
      tradeIds
      activeCurrencies
      sourceAccountId
      sourceAccountSendID
      sourceAccountName
      sourceAccountType
      destinationAccountId
      destinationAccountName
      destinationAccountSendID
      destinationAccountType
      apiOrganisationType
      originalRegistrationId
      financeAccount
      metadata
      name
      code
      ledgerId
      ledgerAccountId
      normalBalance
      vrnLegalAcknowledgement
      frankieUboRequestId
      frankieUboEntityId
      partyName
      partyAddress
      connectionId
      internalAccountId
      accountDetails
      routingDetails
      virtualAccountId
      routingAccountName
      creditLedgerAccountId
      debitLedgerAccountId
      confirmedTradeAmount
      leadConfidence
      nextTaskDueDate
      registrationBoomerangReason
      corporatePurposes
      doesNotUseWebsite
      marketingDescription
      businessHasTrust
      otherBusinessRole
      expectedMargin
      immediateTransfer
      pexaOptInValidated
      pexaOptInAt
      lastField
    }
  }
`;
export const onUpdateCoconutByOwnerTypeV2 = /* GraphQL */ `
  subscription OnUpdateCoconutByOwnerTypeV2($owner: String, $type: String) {
    onUpdateCoconutByOwnerTypeV2(owner: $owner, type: $type) {
      firstField
      id
      type
      owner
      createdBy
      updatedBy
      middleName
      firstName
      lastName
      email
      phone
      authorityFirstName
      authorityMiddleName
      authorityLastName
      authorityEmail
      originalEmail
      authorityPhoneCountryCode
      authorityPhone
      phoneCountryCode
      profilePhoto
      phoneNumberVerified
      smsActivityNotificationsEnabled
      emailMarketingNotificationsEnabled
      emailTransferStatusNotificationsEnabled
      smsTransferStatusNotificationsEnabled
      opportunityLost
      mfaReminderEnabled
      affiliateName
      affiliateId
      affiliateEnabled
      affiliateEmployee
      affiliateEmployeeId
      affiliateEmployeeEmail
      affiliateBranch
      otherSource
      trackingId
      status
      expectedTradingDate
      confidence
      closedDate
      registrationDate
      autoBookedDate
      currencyTo
      currencyFrom
      countryTo
      countryFrom
      purpose
      otherPurpose
      estimatedValue
      unqualifiedReason
      countryOfBirth
      birthDate
      birthDateString
      cxManager
      accountManager
      kycRequest
      kycResponse
      frequency
      fundsGoingtoDiffPerson
      fundsFromCustomer
      kycScore
      kycProvider
      documentIssuedBy
      complianceScore
      documentId
      expiry
      issuer
      currencyCloudId
      currencyCloudContactId
      currencyCloudReference
      documentType
      streetAddress
      streetAddressUnitNumber
      streetAddressNumber
      streetAddressName
      streetAddressType
      city
      state
      postcode
      country
      countryCode
      mfaEnabled
      corporateStreetAddress
      corporateStreetUnitNumber
      corporateStreetNumber
      corporateStreetName
      corporateStreetType
      corporateCity
      corporateState
      corporatePostcode
      corporateCountry
      createdAt
      updatedAt
      qualifiedDate
      ipAddress
      notes
      documentExpiry
      dealing
      bene
      parentId
      parentType
      secondParentId
      secondParentType
      sendId
      counter
      assignee
      inHouseAccount
      manualConvertRegistration
      proposedTradingDate
      proposedMovingDate
      iftiType
      tradeId
      submitDate
      submissionDate
      linkedPaymentId
      overrideFieldsV2
      manualActionFieldsV2
      autoOverrideFields
      beneOverrideFields
      regOverrideFields
      austracErrors
      fileName
      austracReference
      leadId
      isAutoRegistered
      isAutoVerified
      title
      completed
      description
      complianceEvent
      isComplianceCheckList
      stepsTaken
      decisionMade
      decisionVerified
      furtherAction
      verifiedBy
      dueDate
      businessName
      registrationNumber
      businessType
      industry
      website
      businessRole
      beneficiaryBankAccountCountry
      beneficiaryType
      bicSwiftCode
      bsbCode
      bicSwiftAccountNumber
      ibanAccountNumber
      iban
      sortCodeNumber
      clabeNumber
      cnapsNumber
      abaCode
      abaAccountNumber
      ifscNumber
      bankName
      bankCode
      deactivateReason
      accountNumber
      inCurrencyCloud
      lastContact
      beneVerified
      businessRepConfirmed
      termsAccepted
      balances
      docShortId
      docType
      docSubType
      docInstructions
      docIssuingCountry
      docRequestedDate
      docRequestedBy
      docRequestType
      docLicenceVersion
      docExpiryDate
      docExpiryDateString
      docId
      docCardNumber
      docUploadedDate
      docUploadedBy
      docRegion
      docTag
      docStatus
      docAssessmentDate
      docAssessmentBy
      docKey
      docKeys
      showToClient
      docNotApprovedReason
      userId
      lookupType
      lookupValue
      rolename
      permissions
      allowedFields
      userGroups
      features
      affiliates
      unqualifiedReasons
      transferPurposes
      transferAmounts
      countries
      currencies
      blacklistedCurrencies
      newItem
      oldItem
      action
      unread
      customerName
      customerEmail
      customerDefaultPricingPlanId
      targetRate
      accountManagerPhoneNumber
      canSendAccountManagerRateAlert
      accountManagerRateAlertEmailSent
      estAudRevenue
      actualAudRevenue
      tradePenaltyIncome
      settlementDate
      conversionDate
      shortReference
      creatorContactId
      accountId
      iftiWitheld
      iftiWitheldDescription
      currencyPair
      buyCurrency
      sellCurrency
      clientBuyAmount
      clientSellAmount
      sellAmount
      bookedSellAmount
      bookedBuyAmount
      bookedClientRate
      bookedMargin
      fixedSide
      coreRate
      partnerRate
      partnerStatus
      partnerBuyAmount
      partnerSellAmount
      clientRate
      depositRequired
      depositAmount
      depositCurrency
      depositStatus
      depositRequiredAt
      paymentIds
      sendPaymentIds
      documentsRequired
      unallocatedFunds
      fundsReceived
      fullFundsReceived
      thirdPartyPayment
      addressNotValidated
      fullFundsReceivedDate
      uniqueRequestId
      midMarketRate
      amount
      audAmount
      beneficiaryId
      currencyCloudBeneId
      currency
      reference
      reason
      paymentType
      paymentDate
      transferredAt
      authorisationStepsRequired
      lastUpdaterContactId
      conversionId
      sendConversionId
      failureReason
      payerId
      payerDetailsSource
      paymentGroupId
      failureReturnedAmount
      ultimateBeneficiaryName
      purposeCode
      chargeType
      feeAmount
      feeCurrency
      onBehalfOf
      hideFromCustomerActivity
      isFirstTrade
      balanceId
      balanceAmount
      transactionType
      relatedEntityType
      relatedEntityId
      relatedEntityShortReference
      settlesAt
      completedAt
      recipientName
      legacyContractId
      contractSent
      receiptSent
      autoSendContractNote
      manualSendContractNote
      manualSendReceipt
      manualSendTempPassword
      manualSendFundsInEmail
      manualSendDocumentsNeededEmail
      manualSendRegistrationFailed
      sendLeadInvite
      sendNewLeadNotification
      leadSource
      autoPushedToCC
      isCreatedWithoutLead
      isCreatedFromReg
      markAsCompleted
      compliancePending
      beneStatus
      beneCurrencyCloudId
      lastNoteAddedTime
      poaDocInstructions
      poiPhotoDocInstructions
      poiDocInstructions
      invoiceDate
      invoiceNumber
      highRiskCountries
      extremeHighRiskCountries
      highRiskCurrencies
      extremeHighRiskCurrencies
      highRiskPurposes
      values
      groupCaps
      riskDetails
      complexBusinessStructure
      businessOperatingYear
      failedPepSanctionsCheck
      pricingPlanId
      pricingPlanName
      pricingPlanMargin
      pricingPlanOutOfHoursMargin
      pricingPlanDefault
      pricingPlanBankRateComparison
      pricingPlanBankSendingFee
      customerDailyTradeLimit
      highRiskCustomerDailyTradeLimit
      customerMinTradeValue
      customerNotificationCreated
      customerFirstName
      customerLastName
      customerBusinessName
      link
      header
      poliTransactionRef
      portalSource
      error
      field
      rank
      rotation
      current
      value
      utmSource
      mappedAffiliateId
      registrationSource
      expireTime
      margin
      createdSource
      adviserName
      adviserEmail
      adviserPhoneCountryCode
      adviserPhone
      commission
      payInBSB
      payInAccNo
      payInABAStatus
      payInAccountName
      payInPayIdAlias
      payInPayIdStatus
      payInPayIdName
      payInBPayCRN
      payInBPayBillerCode
      incomingFundType
      incomingFundProvider
      incomingFundDetails
      paymentReference
      loginSource
      notificationType
      pricingStructureType
      pricingStructureSettings
      beneficiariesOfTrust
      directors
      webhookSecret
      transactionalApiWebhookUrls
      transactionalAPIRegistration
      eburyRegistration
      eburyNumber
      storeAUDRevenueInCC
      syncedEvent
      syncedAt
      tradeIds
      activeCurrencies
      sourceAccountId
      sourceAccountSendID
      sourceAccountName
      sourceAccountType
      destinationAccountId
      destinationAccountName
      destinationAccountSendID
      destinationAccountType
      apiOrganisationType
      originalRegistrationId
      financeAccount
      metadata
      name
      code
      ledgerId
      ledgerAccountId
      normalBalance
      vrnLegalAcknowledgement
      frankieUboRequestId
      frankieUboEntityId
      partyName
      partyAddress
      connectionId
      internalAccountId
      accountDetails
      routingDetails
      virtualAccountId
      routingAccountName
      creditLedgerAccountId
      debitLedgerAccountId
      confirmedTradeAmount
      leadConfidence
      nextTaskDueDate
      registrationBoomerangReason
      corporatePurposes
      doesNotUseWebsite
      marketingDescription
      businessHasTrust
      otherBusinessRole
      expectedMargin
      immediateTransfer
      pexaOptInValidated
      pexaOptInAt
      lastField
    }
  }
`;
export const onDeleteCoconutByOwnerTypeV2 = /* GraphQL */ `
  subscription OnDeleteCoconutByOwnerTypeV2($type: String) {
    onDeleteCoconutByOwnerTypeV2(type: $type) {
      firstField
      id
      type
      owner
      createdBy
      updatedBy
      middleName
      firstName
      lastName
      email
      phone
      authorityFirstName
      authorityMiddleName
      authorityLastName
      authorityEmail
      originalEmail
      authorityPhoneCountryCode
      authorityPhone
      phoneCountryCode
      profilePhoto
      phoneNumberVerified
      smsActivityNotificationsEnabled
      emailMarketingNotificationsEnabled
      emailTransferStatusNotificationsEnabled
      smsTransferStatusNotificationsEnabled
      opportunityLost
      mfaReminderEnabled
      affiliateName
      affiliateId
      affiliateEnabled
      affiliateEmployee
      affiliateEmployeeId
      affiliateEmployeeEmail
      affiliateBranch
      otherSource
      trackingId
      status
      expectedTradingDate
      confidence
      closedDate
      registrationDate
      autoBookedDate
      currencyTo
      currencyFrom
      countryTo
      countryFrom
      purpose
      otherPurpose
      estimatedValue
      unqualifiedReason
      countryOfBirth
      birthDate
      birthDateString
      cxManager
      accountManager
      kycRequest
      kycResponse
      frequency
      fundsGoingtoDiffPerson
      fundsFromCustomer
      kycScore
      kycProvider
      documentIssuedBy
      complianceScore
      documentId
      expiry
      issuer
      currencyCloudId
      currencyCloudContactId
      currencyCloudReference
      documentType
      streetAddress
      streetAddressUnitNumber
      streetAddressNumber
      streetAddressName
      streetAddressType
      city
      state
      postcode
      country
      countryCode
      mfaEnabled
      corporateStreetAddress
      corporateStreetUnitNumber
      corporateStreetNumber
      corporateStreetName
      corporateStreetType
      corporateCity
      corporateState
      corporatePostcode
      corporateCountry
      createdAt
      updatedAt
      qualifiedDate
      ipAddress
      notes
      documentExpiry
      dealing
      bene
      parentId
      parentType
      secondParentId
      secondParentType
      sendId
      counter
      assignee
      inHouseAccount
      manualConvertRegistration
      proposedTradingDate
      proposedMovingDate
      iftiType
      tradeId
      submitDate
      submissionDate
      linkedPaymentId
      overrideFieldsV2
      manualActionFieldsV2
      autoOverrideFields
      beneOverrideFields
      regOverrideFields
      austracErrors
      fileName
      austracReference
      leadId
      isAutoRegistered
      isAutoVerified
      title
      completed
      description
      complianceEvent
      isComplianceCheckList
      stepsTaken
      decisionMade
      decisionVerified
      furtherAction
      verifiedBy
      dueDate
      businessName
      registrationNumber
      businessType
      industry
      website
      businessRole
      beneficiaryBankAccountCountry
      beneficiaryType
      bicSwiftCode
      bsbCode
      bicSwiftAccountNumber
      ibanAccountNumber
      iban
      sortCodeNumber
      clabeNumber
      cnapsNumber
      abaCode
      abaAccountNumber
      ifscNumber
      bankName
      bankCode
      deactivateReason
      accountNumber
      inCurrencyCloud
      lastContact
      beneVerified
      businessRepConfirmed
      termsAccepted
      balances
      docShortId
      docType
      docSubType
      docInstructions
      docIssuingCountry
      docRequestedDate
      docRequestedBy
      docRequestType
      docLicenceVersion
      docExpiryDate
      docExpiryDateString
      docId
      docCardNumber
      docUploadedDate
      docUploadedBy
      docRegion
      docTag
      docStatus
      docAssessmentDate
      docAssessmentBy
      docKey
      docKeys
      showToClient
      docNotApprovedReason
      userId
      lookupType
      lookupValue
      rolename
      permissions
      allowedFields
      userGroups
      features
      affiliates
      unqualifiedReasons
      transferPurposes
      transferAmounts
      countries
      currencies
      blacklistedCurrencies
      newItem
      oldItem
      action
      unread
      customerName
      customerEmail
      customerDefaultPricingPlanId
      targetRate
      accountManagerPhoneNumber
      canSendAccountManagerRateAlert
      accountManagerRateAlertEmailSent
      estAudRevenue
      actualAudRevenue
      tradePenaltyIncome
      settlementDate
      conversionDate
      shortReference
      creatorContactId
      accountId
      iftiWitheld
      iftiWitheldDescription
      currencyPair
      buyCurrency
      sellCurrency
      clientBuyAmount
      clientSellAmount
      sellAmount
      bookedSellAmount
      bookedBuyAmount
      bookedClientRate
      bookedMargin
      fixedSide
      coreRate
      partnerRate
      partnerStatus
      partnerBuyAmount
      partnerSellAmount
      clientRate
      depositRequired
      depositAmount
      depositCurrency
      depositStatus
      depositRequiredAt
      paymentIds
      sendPaymentIds
      documentsRequired
      unallocatedFunds
      fundsReceived
      fullFundsReceived
      thirdPartyPayment
      addressNotValidated
      fullFundsReceivedDate
      uniqueRequestId
      midMarketRate
      amount
      audAmount
      beneficiaryId
      currencyCloudBeneId
      currency
      reference
      reason
      paymentType
      paymentDate
      transferredAt
      authorisationStepsRequired
      lastUpdaterContactId
      conversionId
      sendConversionId
      failureReason
      payerId
      payerDetailsSource
      paymentGroupId
      failureReturnedAmount
      ultimateBeneficiaryName
      purposeCode
      chargeType
      feeAmount
      feeCurrency
      onBehalfOf
      hideFromCustomerActivity
      isFirstTrade
      balanceId
      balanceAmount
      transactionType
      relatedEntityType
      relatedEntityId
      relatedEntityShortReference
      settlesAt
      completedAt
      recipientName
      legacyContractId
      contractSent
      receiptSent
      autoSendContractNote
      manualSendContractNote
      manualSendReceipt
      manualSendTempPassword
      manualSendFundsInEmail
      manualSendDocumentsNeededEmail
      manualSendRegistrationFailed
      sendLeadInvite
      sendNewLeadNotification
      leadSource
      autoPushedToCC
      isCreatedWithoutLead
      isCreatedFromReg
      markAsCompleted
      compliancePending
      beneStatus
      beneCurrencyCloudId
      lastNoteAddedTime
      poaDocInstructions
      poiPhotoDocInstructions
      poiDocInstructions
      invoiceDate
      invoiceNumber
      highRiskCountries
      extremeHighRiskCountries
      highRiskCurrencies
      extremeHighRiskCurrencies
      highRiskPurposes
      values
      groupCaps
      riskDetails
      complexBusinessStructure
      businessOperatingYear
      failedPepSanctionsCheck
      pricingPlanId
      pricingPlanName
      pricingPlanMargin
      pricingPlanOutOfHoursMargin
      pricingPlanDefault
      pricingPlanBankRateComparison
      pricingPlanBankSendingFee
      customerDailyTradeLimit
      highRiskCustomerDailyTradeLimit
      customerMinTradeValue
      customerNotificationCreated
      customerFirstName
      customerLastName
      customerBusinessName
      link
      header
      poliTransactionRef
      portalSource
      error
      field
      rank
      rotation
      current
      value
      utmSource
      mappedAffiliateId
      registrationSource
      expireTime
      margin
      createdSource
      adviserName
      adviserEmail
      adviserPhoneCountryCode
      adviserPhone
      commission
      payInBSB
      payInAccNo
      payInABAStatus
      payInAccountName
      payInPayIdAlias
      payInPayIdStatus
      payInPayIdName
      payInBPayCRN
      payInBPayBillerCode
      incomingFundType
      incomingFundProvider
      incomingFundDetails
      paymentReference
      loginSource
      notificationType
      pricingStructureType
      pricingStructureSettings
      beneficiariesOfTrust
      directors
      webhookSecret
      transactionalApiWebhookUrls
      transactionalAPIRegistration
      eburyRegistration
      eburyNumber
      storeAUDRevenueInCC
      syncedEvent
      syncedAt
      tradeIds
      activeCurrencies
      sourceAccountId
      sourceAccountSendID
      sourceAccountName
      sourceAccountType
      destinationAccountId
      destinationAccountName
      destinationAccountSendID
      destinationAccountType
      apiOrganisationType
      originalRegistrationId
      financeAccount
      metadata
      name
      code
      ledgerId
      ledgerAccountId
      normalBalance
      vrnLegalAcknowledgement
      frankieUboRequestId
      frankieUboEntityId
      partyName
      partyAddress
      connectionId
      internalAccountId
      accountDetails
      routingDetails
      virtualAccountId
      routingAccountName
      creditLedgerAccountId
      debitLedgerAccountId
      confirmedTradeAmount
      leadConfidence
      nextTaskDueDate
      registrationBoomerangReason
      corporatePurposes
      doesNotUseWebsite
      marketingDescription
      businessHasTrust
      otherBusinessRole
      expectedMargin
      immediateTransfer
      pexaOptInValidated
      pexaOptInAt
      lastField
    }
  }
`;
